import styled from "styled-components";

export const InputPasswordStepWrapper = styled.div`
  .MuiFormControl-root,
  button {
    margin-top: 10px;
  }
`;